module.exports = __webpack_public_path__ + "img/Poland.8f267639.jpg";